module.exports = __webpack_public_path__ + "img/electron-gold.c634ff78.svg";